import { PAYMENT_TYPE } from './constants.js';
export const PAYROLL_DEDUCTION_ORGANIZATION_UUID = 'dbeea528-852e-43d0-b607-c8201d7a5f1c';
export const HENSON_FUND_REPORT_ORGANIZATION_UUID = PAYROLL_DEDUCTION_ORGANIZATION_UUID;
export const isPayrollDeductionEnabled = (organizationUUID) => String(organizationUUID ?? '')
    .trim()
    .toLowerCase() === PAYROLL_DEDUCTION_ORGANIZATION_UUID;
export const isHensonFundReportEnabled = (organizationUUID) => isPayrollDeductionEnabled(organizationUUID);
export const BLOCKTICKETS_ORGANIZATION_NAME = 'blocktickets';
export const isBlockticketsOrganization = (organization) => {
    const name = typeof organization === 'string' ? organization : organization?.name;
    return (String(name ?? '')
        .trim()
        .toLowerCase() === BLOCKTICKETS_ORGANIZATION_NAME);
};
export const canViewAccountingReport = ({ organization, organizationName, isSuperAdmin, } = {}) => Boolean(isSuperAdmin) &&
    isBlockticketsOrganization(organizationName ?? organization);
export const assertPayrollDeductionAllowed = (paymentMethod, organizationUUID) => {
    const normalized = String(paymentMethod ?? '')
        .trim()
        .toLowerCase()
        .replace(/-/g, '_');
    if (normalized === PAYMENT_TYPE.PAYROLL_DEDUCTION &&
        !isPayrollDeductionEnabled(organizationUUID)) {
        throw new Error('Payroll deduction is not available for this organization');
    }
};
